import React from 'react';
import { Heart, Users, Zap } from 'lucide-react';
import { CircuitPaths, CharReveal, TiltCard, Reveal } from './TerminalEffects';

export const ValuesSection = () => {
  const values = [
    {
      icon: Heart,
      title: 'Driven by passion',
      description: "At HiBotics AI, we're genuinely passionate about how AI can make everyday business simpler. We believe this technology should work quietly in the background, handling repetitive tasks so business owners can focus on what they do best.",
      accent: '#00FFD1'
    },
    {
      icon: Users,
      title: 'Focused on clients',
      description: 'Our clients are at the centre of everything we do. We take the time to understand how each business operates. By focusing on practical solutions, clear communication, and reliable support, we make sure our AI assistants genuinely add value from day one.',
      accent: '#C4956A'
    },
    {
      icon: Zap,
      title: 'Quality and speed',
      description: "We believe great solutions should be delivered quickly — without compromising on quality. That's why we focus on building reliable, high-performance AI assistants that are ready to work from day one.",
      accent: '#7DFFD4'
    }
  ];

  return (
    <section className="relative py-28 bg-[#D4F7DC] overflow-hidden" data-testid="values-section">
      <CircuitPaths />
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10">
        <Reveal>
          <div className="mb-20 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            <div>
              <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C4956A] mb-4">Our Values</p>
              <CharReveal text="Why Choose HiBotics AI" tag="h2"
                className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#2A2A2A] leading-[1.05]" />
            </div>
            <p className="text-base text-[#2A2A2A]/60 max-w-[380px] leading-relaxed">
              We combine cutting-edge AI with genuine care for your business success.
            </p>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <Reveal key={value.title} delay={index * 150}>
                <TiltCard accentColor={value.accent} className="h-full">
                  <div className="bg-[#1e1e1e] rounded-2xl p-8 flex flex-col h-full relative overflow-hidden"
                    data-testid={`value-card-${index}`}>
                    <div className="absolute top-0 left-0 right-0 h-[3px]" style={{ background: `linear-gradient(90deg, ${value.accent}, transparent)` }} />
                    <div className="mb-6">
                      <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: `${value.accent}20`, border: `1px solid ${value.accent}30` }}>
                        <Icon size={22} style={{ color: value.accent }} />
                      </div>
                    </div>
                    <h3 className="text-xl font-semibold text-[#F5F0E0] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>{value.title}</h3>
                    <p className="text-sm text-[#F5F0E0]/70 leading-relaxed flex-1" style={{ fontFamily: "'Manrope', sans-serif" }}>{value.description}</p>
                  </div>
                </TiltCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
